import UrlParser from 'url-parse';

import { RedirectFlow, RedirectFlowStatus } from './constants';

const addQueryParams = (parsedUrl, queryObject) => {
    parsedUrl.set('query', {
        ...parsedUrl.query,
        ...queryObject,
    });
};

export default function buildRedirectUrls() {
    const currentUrl = window.location.href;
    const parsedConfirmationUrl = UrlParser(currentUrl, true);
    const parsedCancellationUrl = UrlParser(currentUrl, true);

    if (window.location.hostname === 'localhost') {
        // does not work with localhost
        parsedConfirmationUrl.set('hostname', '127.0.0.1');
        parsedCancellationUrl.set('hostname', '127.0.0.1');
    }

    addQueryParams(parsedConfirmationUrl, {
        [RedirectFlow.QueryParamPaymentStatus]: RedirectFlowStatus.Success,
    });
    addQueryParams(parsedCancellationUrl, {
        [RedirectFlow.QueryParamPaymentStatus]: RedirectFlowStatus.Failure,
    });

    return {
        confirm_url: parsedConfirmationUrl.href,
        cancel_url: parsedCancellationUrl.href,
    };
}
